import { render } from "./court-count.vue?vue&type=template&id=37a5e81c&scoped=true"
import script from "./court-count.vue?vue&type=script&lang=js"
export * from "./court-count.vue?vue&type=script&lang=js"

import "./court-count.vue?vue&type=style&index=0&id=37a5e81c&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a5e81c"]])

export default __exports__